import { Clock as BS_Clock, OneHundredTwentyThree, PlusCircle } from "@styled-icons/bootstrap";
import { Clock } from "assets/icons";
import { ResetAction } from "components/actions";
import { DropdownSetting, InformationSetting, ToggleSetting } from "components/settings";
import { RememberSettings } from "components/settings";
import { ChooseBetweenButtonsSetting } from "components/settings/generic/ChooseBetweenButtons";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { InteractiveClock, InteractiveClockState } from "./InteractiveClock";

const aspect = 0.75;

export const InteractiveClockWidget: WidgetType<InteractiveClockState> = {
  name: "Clock",
  component: InteractiveClock,
  icon: Clock,
  showOnToolbar: true,
  sizing: {
    minWidth: 117,
    minHeight: 156,
    minAspectRatio: aspect,
    maxAspectRatio: aspect,
  },
  defaultState: {
    handPositions: { hours: 0, minutes: 0, seconds: 0 },
  },
  defaultSize: {
    aspectRatio: aspect,
    widthPercentage: 16,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "A widget where the hour, minute, and second hands can be interacted with.",
      },
    },
    clockFace: {
      editor: ChooseBetweenButtonsSetting,
      info: {
        label: "Clock Face",
        choices: [
          {
            name: "Analogue",
            value: "a",
            icon: BS_Clock,
          },
          {
            name: "Digital",
            value: "d",
            icon: OneHundredTwentyThree,
          },
          {
            name: "Analogue & Digital",
            value: "a_d",
            icon: PlusCircle,
          },
        ],
      },
      defaultValue: "a_d",
    },
    is24Hour: {
      editor: DropdownSetting,
      info: {
        name: "Type of Clock",
        options: ["12 Hour", "24 Hour"],
      },
      defaultValue: "12 Hour",
    },
    showSeconds: {
      editor: ToggleSetting,
      info: {
        label: "Show Seconds?",
      },
      defaultValue: true,
    },
    controlHands: {
      editor: ToggleSetting,
      info: {
        label: "Move Hands Independently?",
      },
      defaultValue: false,
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.interactiveClock,
        widgetDisplayName: "Clock",
      },
    },
  },
  quickActions: {
    reset: ResetAction,
  },
};
